export const TAB_STATUS_TODO = 'TAB_STATUS_TODO';
export const TAB_STATUS_DONE = 'TAB_STATUS_DONE';
export const TAB_STATUS_ALL = 'TAB_STATUS_ALL';
export const TAB_STATUS_CONS = 'TAB_STATUS_CONS';
